// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"448":"d49151ce","518":"fe90a810","722":"1b797525","780":"ce3e0260","805":"606e11c2","858":"51c361e3"}[chunkId] + ".chunk.css";
};